export default __webpack_public_path__ + "media/images/tenant/chooseTabas/reason_3-54d640a28d4cd2aa3d28416a259c8f15.webp";